var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.24659 2.77901C5.24624 3.51568 4.96953 4.22204 4.47732 4.74268C3.98511 5.26333 3.31772 5.55562 2.62198 5.55525C1.92624 5.55488 1.25914 5.26188 0.767418 4.74072C0.275701 4.21955 -0.000347542 3.51291 3.28386e-07 2.77624C0.000348199 2.03956 0.277064 1.33321 0.769273 0.812565C1.26148 0.29192 1.92887 -0.000367988 2.62461 3.47705e-07C3.32035 0.000368683 3.98746 0.293363 4.47917 0.814529C4.97089 1.3357 5.24694 2.04234 5.24659 2.77901ZM5.32529 7.61208H0.0786991V25H5.32529V7.61208ZM13.6149 7.61208H8.39454V25H13.5624V15.8755C13.5624 10.7925 19.819 10.3203 19.819 15.8755V25H25V13.9867C25 5.41775 15.7398 5.73718 13.5624 9.94528L13.6149 7.61208Z",
    fill: "#111827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.96c2f25582575fe78746b8d7e2d2221a.svg";
export { ForwardRef as ReactComponent };